import React from "react";
import Header from "../Header/Header";
import { connect, links } from "../../portfolio.js";

function Contact() {
  return (
    <div>
      <div className="contact_div ">
        <div className="dd pt-5 pb-5">
          <Header title="Let's Connect" />

          <div className="container-fluid conn-sm">
            <div className="row ">
              <div className="col-12 col-md-6 col-sm-12 mx-auto ">
                <div className="card m-3 contact_back">
                  <div className="card-body">
                    <h3 style={{ color: "white" }}>Contact Information</h3>
                    <p className="f_color">Fill up the form and click send.</p>
                    <ul>
                      {connect.connect_data.map((val, idx) => {
                        return (
                          <h6 style={{ color: "var(--contact_color" }}>
                            <i className={val[0]}></i> {val[1]}
                          </h6>
                        );
                      })}
                    </ul>
                    <div id="social">
                      <div id="container">
                        <ul style={{ alignItems: "center" }}>
                          {links.links_data.map((item) => {
                            return (
                              <li key={item.name}>
                                <a href={item.url}>
                                  <i className={item.className}></i>
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-sm-12 mx-auto">
                <form
                  action="https://formcarry.com/s/MIqL1g5HUr6"
                  method="POST"
                  accept-charset="UTF-8"
                >
                  <div className="input-group mb-3">
                    <span className="input-group-text" id="basic-addon1">
                      <i
                        className="fa fa-user"
                        style={{ color: "#570d8b" }}
                      ></i>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Username"
                      name="anotherInput"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First Name"
                      name="firstName"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                    <input type="hidden" name="_gotcha"></input>
                  </div>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last Name"
                      aria-label="Username"
                      name="lastName"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone"
                      name="anotherInput"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />
                    <span className="input-group-text" id="basic-addon2">
                      <i style={{ color: "#570d8b" }} class="fa fa-phone"></i>
                    </span>
                  </div>

                  <div className="input-group mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Recipient's gmail"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />
                    <span className="input-group-text" id="basic-addon2">
                      example@gmail.com
                    </span>
                  </div>

                  <div className="input-group">
                    <span className="input-group-text">Message</span>
                    <textarea
                      className="form-control"
                      aria-label="With textarea"
                      name="anotherInput"
                    ></textarea>
                  </div>
                  <div className="mt-3">
                    <button
                      type="submit"
                      to="/"
                      className="btn-get-started main-color"
                      style={{ backgroundColor: "#570d8b" }}
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
